/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default {
    NULL_SUBSTITUTION_VALUE: '~NULL~',
    NULL_SUBSTITUTION_LABEL: '[Null]',
    NOTHING_SUBSTITUTION_VALUE: '~NOTHING~'
};